module.exports = __webpack_public_path__ + "static/media/results_table_column_dropdown.45657c9c.png";